import { useDateUtils } from '../../../utils';
export var useIsSelectingDifferentDate = () => {
  var {
    isDatePartEqual
  } = useDateUtils();

  var isSelectingDifferentDate = currentValue => newValue => !currentValue || !isDatePartEqual(newValue, currentValue);

  return {
    isSelectingDifferentDate
  };
};
//# sourceMappingURL=DatePicker.utils.js.map